import { Colors } from '~/themes/colors';
import { IIconProps } from './Types';

export const ChatOutlineIcon = ({ color = Colors.secondary_500, size = 24 }: IIconProps) => (
  <svg fill="none" height={size} viewBox="0 0 25 24" width={size}>
    <path
      d="M17.1303 8H19.1456C20.2586 8 21.1608 8.89543 21.1608 10V16C21.1608 17.1046 20.2586 18 19.1456 18H17.1303V22L13.0998 18H9.06924C8.51274 18 8.00892 17.7761 7.64423 17.4142M7.64423 17.4142L11.0845 14H15.115C16.228 14 17.1303 13.1046 17.1303 12V6C17.1303 4.89543 16.228 4 15.115 4H5.0387C3.9257 4 3.02344 4.89543 3.02344 6V12C3.02344 13.1046 3.9257 14 5.0387 14H7.05397V18L7.64423 17.4142Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
